<template lang="pug">
div(style="margin-bottom: 16px;")
    Row(:gutter="16")
        Col(span="6")
            Checkbox(:value="value.profile" @on-change="onChange('profile', $event)" :disabled="disabled || isNotAppProfile") {{ cacheKeyLabels.profile }}
        Col(span="6")
            Checkbox(:value="false" @on-change="onChange('originHost', false)" disabled) {{ cacheKeyLabels.originHost }}
        Col(span="6")
            Checkbox(:value="false" @on-change="onChange('originHostResolve', false)" disabled) {{ cacheKeyLabels.originHostResolve }}
        Col(span="6")
            Checkbox(:value="value.host" @on-change="onChange('host', $event)" :disabled="disabled") {{ cacheKeyLabels.host }}
    Row(:gutter="16")
        Col(span="6")
            Checkbox(:value="value.customSign" @on-change="onChange('customSign', $event)" :disabled="disabled") {{ cacheKeyLabels.customSign }}
            Input(v-if="value.customSign" :value="value.customSignValue" @on-blur="onChange('customSignValue', $event.target.value)" @on-change="onChange('customSignValue', $event.target.value)" :disabled="disabled" placeholder="example")
</template>
<script>
export default {
    name: "CacheKeyForm",
    props: ["formItem", "formData", "value"],
    computed: {
        disabled() {
            return typeof this.formItem.disabled == "function" ? this.formItem.disabled() : this.formItem.disabled;
        },
        isNotAppProfile() {
            return this.formData.appProfileName === "none";
        },
        cacheKeyLabels() {
            return {
                profile: this.$t("domainsetting.appProfileName"),
                originHost: this.$t("domainsetting.originHost"),
                originHostResolve: this.$t("domainsetting.originHostResolve"),
                host: this.$t("domainsetting.servername"),
                customSign: this.$t("domainsetting.customSign"),
            };
        },
    },
    watch: {
        value: {
            handler(newVal) {
                if (
                    newVal &&
                    (newVal.originHost !== false || newVal.originHostResolve !== false)
                ) {
                    this.$emit("input", {
                        ...newVal,
                        originHost: false,
                        originHostResolve: false,
                    });
                }
            },
            immediate: true,
            deep: true,
        },
        isNotAppProfile(newVal) {
            if (newVal && this.value.profile) {
                this.onChange("profile", false);
            }
        },
    },
    methods: {
        onChange(key, val) {
            this.$emit("input", {
                ...this.value,
                [key]: val,
                originHost: false,
                originHostResolve: false,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/CacheKeyForm.vue